import { Container, Grid, Typography, Alert, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Form, SimpleSelect, Submit } from "../Form";
import { useState } from "react";
import { useForm } from "react-hook-form";
import axios from 'axios';
import { url } from "../../api";
import { useDispatch } from "react-redux";
import { startSending, endSending } from "../../features/progress/pogressSlice";

const FormRegister = () => {
    const token = localStorage.getItem('token')
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [severity, setSeverity] = useState('success');
    const [option, setOption] = useState("");
    const [message, setMessage] = useState("");
    const handleChange = event => setOption(event.target.value)
    const methods = useForm({ shouldUnregister: true })
    
    const onSubmit = async (_) => {
        if(!selectedFile.name.includes('.csv')) {
            setOpen(true)
            setSeverity('error')
            return setMessage('Se esperaba archivo CSV')
        }
        dispatch(startSending())
        const formData = new FormData();
        formData.append('uploaded_file', selectedFile)
        try {
            const { data } = await axios({
                method: "post",
                url: `${url}/${option}`,
                data: formData,
                headers: { 
                    "Content-Type": "multipart/form-data",
                    "x-access-token": token
                }
            })
            dispatch(endSending())
            setMessage(data.msg)
            setSeverity('success')
            setOpen(true)
            resetForm()
        } catch (error) {
            console.log(error);
            dispatch(endSending())
            resetForm()
            setOpen(true)
            setSeverity('error')
            setMessage(error.response.data.msg || error.message)
        }
    }
    const handleFileSelect = event => setSelectedFile(event.target.files[0])
    const options = [{ id: 'csv/staff', nombre: 'Administrativos' }, { id: 'csv/events', nombre: 'Asistencia a Eventos' }, { id: 'csv', nombre: 'Estudiantes' }, { id: 'csv/teachers', nombre: 'Profesores' }, ]
    const resetForm = () => {
        document.getElementById('form').reset();
        setOption('')
    }
    return(
        <Container maxWidth={'xs'} sx={{ p: '2em' }}>
            <Typography variant="body1" align="center" gutterBottom>Selecciona el tipo de registro que deseas hacer!</Typography>
            <Form methods={methods} onSubmit={onSubmit} >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <SimpleSelect name={'tipo'} label={'Tipo'} options={options} val={option} onChange={handleChange}/>
                    </Grid>
                    { option ? (
                        <>
                            <Grid item xs={12} sm={12} md={12}>
                                <input type={'file'} name="uploaded_file" onChange={handleFileSelect} />
                            </Grid>
                            <Submit title="Registrar" size={12} />
                        </>
                    ) : null }
                </Grid>
            </Form>
            { open ? (
                <Alert 
                    action={
                        <IconButton color="inherit" size="small" onClick={() => setOpen(false)}>
                            <Close />
                        </IconButton> } 
                    severity={severity} sx={{ mt: '1em' }} 
                >
                    {message} 
                </Alert> 
            ) : null}
        </Container>
    )
}

export default FormRegister;